import React, { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem('cookie_consent')) setVisible(true);
    }, 600);
    return () => clearTimeout(t);
  }, []);

  const dismiss = (val) => {
    localStorage.setItem('cookie_consent', val);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-5 left-5 z-[60] w-[340px] rounded-xl border border-[#E6DDC8] bg-white p-5 shadow-2xl">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F6F2EA] text-[#C9A86A]">
            <Cookie size={16} />
          </div>
          <h5 className="text-[15px] font-semibold text-[#0B2545]">
            Cookie Notice
          </h5>
        </div>
        <button
          onClick={() => dismiss('dismissed')}
          className="text-[#0B2545]/60 hover:text-[#0B2545]"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>
      <p className="mb-4 text-[12.5px] leading-relaxed text-[#0B2545]/70">
        We use cookies to improve your experience on this site, analyse traffic
        and support our services. By clicking "Accept", you agree to our use of
        cookies. Read our{' '}
        <a href="#" className="text-[#C9A86A] underline">
          Cookie Policy
        </a>{' '}
        and{' '}
        <a href="#" className="text-[#C9A86A] underline">
          Privacy Policy
        </a>
        .
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={() => dismiss('accepted')}
          className="rounded-md bg-[#C9A86A] px-4 py-2 text-[13px] font-medium text-white hover:bg-[#b8975c]"
        >
          Accept All
        </button>
        <button
          onClick={() => dismiss('declined')}
          className="rounded-md border border-[#E6DDC8] px-4 py-2 text-[13px] font-medium text-[#0B2545] hover:bg-[#F6F2EA]"
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
